/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React, { useEffect, useState, createContext } from 'react';
import type { TrackingServiceV3 } from '../app/feature-service-types';

import { Banner } from './components/Banner';

import { aemhContentTransformation } from './aemhContentTransformation';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { getThemeName } from '../alpha-helper';

export const ContextServiceTracking = createContext<TrackingServiceV3 | undefined>(undefined);

export const FeatureApp: React.FC<FeatureAppProps> = ({
  serviceTracking,
  serviceContent,
}: FeatureAppProps) => {
  const [rawContent, setContent] = useState(serviceContent.getContent() as unknown as ContentAem);
  useEffect(() => {
    serviceContent.onContentChange(() => {
      setContent(serviceContent.getContent() as ContentAem);
    });
  }, [serviceContent]);

  const content: Banner = aemhContentTransformation(rawContent);

  return (
    <ContextServiceTracking.Provider value={serviceTracking}>
      <ThemeProvider theme={{ name: getThemeName(content.theme) }}>
        <Banner {...content} />
      </ThemeProvider>
    </ContextServiceTracking.Provider>
  );
};

export default FeatureApp;
